import { IFont } from './plan-primitive';

/**
 * Text-width port for a plan projection. The projection stays canvas-free; the
 * production adapter wraps `ctx.measureText`, the test adapter is a
 * deterministic monospace estimate. Two adapters → a real seam.
 */
export interface ITextMeasurer {
    measure(text: string, font: IFont): number;
}

/** Production adapter — measures with the real 2D context. */
export function createCanvasTextMeasurer(ctx: CanvasRenderingContext2D): ITextMeasurer {
    return {
        measure(text: string, font: IFont): number {
            const previousFont: string = ctx.font;
            ctx.font = `${String(font.weight)} ${String(font.size)}px ${font.family}`;
            const width: number = ctx.measureText(text).width;
            ctx.font = previousFont;
            return width;
        },
    };
}

const MONOSPACE_ADVANCE_RATIO: number = 0.6;

/** Deterministic test adapter — no canvas, monospace estimate. */
export const monospaceTextMeasurer: ITextMeasurer = {
    measure(text: string, font: IFont): number {
        return text.length * font.size * MONOSPACE_ADVANCE_RATIO;
    },
};
